import React from 'react';
import { IIconProps } from './utils';

export const Skip = ({
  fill = 'currentColor', height = 14, width = 14, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 14 14"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.0827 2.91699L6.99935 7.00033L2.91602 11.0837M6.99935 12.8337C3.77769 12.8337 1.16602 10.222 1.16602 7.00033C1.16602 3.77866 3.77769 1.16699 6.99935 1.16699C10.221 1.16699 12.8327 3.77866 12.8327 7.00033C12.8327 10.222 10.221 12.8337 6.99935 12.8337Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.16667}
    />
  </svg>
);
